<form [formGroup]="settingsForm" (keydown.enter)="$event.preventDefault()" (ngSubmit)="save()">
    <div class="card">
        <div class="card-header mm-card-header">
            Settings
        </div>
        <div class="card-body col-md-12">
            <div class="mb-3 d-flex align-items-center">
                <input type="checkbox" id="isHeapEnabled" class="me-2 mt-0" formControlName="isHeapEnabled">
                <label for="heapEnabled" class="mb-0">
                    Enable Heap for this Enterprise
                </label>
            </div>
            <div class="mb-3 d-flex align-items-center">
                <input type="checkbox" id="isMfaEnabled" class="me-2 mt-0" formControlName="isMfaEnabled">
                <label for="isMfaEnabled" class="mb-0">
                    Enable MFA for this Enterprise
                </label>
            </div>
        </div>
    </div>
    <br>
    <button type="submit" class="btn btn-sm btn-primary me-2" [disabled]="!isLoaded || isSaving" (click)="save()">Save</button>
    <button type="button" class="btn btn-sm btn-outline-primary" (click)="cancel()">Cancel</button>
</form>
